import { createNS } from "@ontologies/core";
/** Function to create arbitrary terms within the 'Friend of a Friend (FOAF) vocabulary' ontology */
export const ns = createNS("http://xmlns.com/foaf/0.1/");
/** A foaf:LabelProperty is any RDF property with texual values that serve as labels. */
export const LabelProperty = ns("LabelProperty");
/** A person. */
export const Person = ns("Person");
/** An agent (eg. person, group, software or physical artifact). */
export const Agent = ns("Agent");
/** A document. */
export const Document = ns("Document");
/** An organization. */
export const Organization = ns("Organization");
/** A class of Agents. */
export const Group = ns("Group");
/** A project (a collective endeavour of some kind). */
export const Project = ns("Project");
/** An image. */
export const Image = ns("Image");
/** A personal profile RDF document. */
export const PersonalProfileDocument = ns("PersonalProfileDocument");
/** An online account. */
export const OnlineAccount = ns("OnlineAccount");
/** An online gaming account. */
export const OnlineGamingAccount = ns("OnlineGamingAccount");
/** An online e-commerce account. */
export const OnlineEcommerceAccount = ns("OnlineEcommerceAccount");
/** An online chat account. */
export const OnlineChatAccount = ns("OnlineChatAccount");
/** A
personal mailbox, ie. an Internet mailbox associated with exactly one owner, the first owner of this mailbox. This is a 'static inverse functional property', in that  there is (across time and change) at most one individual that ever has any particular value for foaf:mbox. */
export const mbox = ns("mbox");
/** The sha1sum of the URI of an Internet mailbox associated with exactly one owner, the  first owner of the mailbox. */
export const mbox_sha1sum = ns("mbox_sha1sum");
/** The gender of this Agent (typically but not necessarily 'male' or 'female'). */
export const gender = ns("gender");
/** A textual geekcode for this person, see http://www.geekcode.com/geek.html */
export const geekcode = ns("geekcode");
/** A checksum for the DNA of some thing. Joke. */
export const dnaChecksum = ns("dnaChecksum");
/** A sha1sum hash, in hex. */
export const sha1 = ns("sha1");
/** A location that something is based near, for some broadly human notion of near. */
export const based_near = ns("based_near");
/** Title (Mr, Mrs, Ms, Dr. etc) */
export const title = ns("title");
/** A short informal nickname characterising an agent (includes login identifiers, IRC and other chat nicknames). */
export const nick = ns("nick");
/** A jabber ID for something. */
export const jabberID = ns("jabberID");
/** An AIM chat ID */
export const aimChatID = ns("aimChatID");
/** A Skype ID */
export const skypeID = ns("skypeID");
/** An ICQ chat ID */
export const icqChatID = ns("icqChatID");
/** A Yahoo chat ID */
export const yahooChatID = ns("yahooChatID");
/** An MSN chat ID */
export const msnChatID = ns("msnChatID");
/** A name for some thing. */
export const name = ns("name");
/** The first name of a person. */
export const firstName = ns("firstName");
/** The last name of a person. */
export const lastName = ns("lastName");
/** The given name of some person. */
export const givenName = ns("givenName");
/** The given name of some person. */
export const givenname = ns("givenname");
/** The surname of some person. */
export const surname = ns("surname");
/** The family name of some person. */
export const family_name = ns("family_name");
/** The family name of some person. */
export const familyName = ns("familyName");
/** A phone,  specified using fully qualified tel: URI scheme (refs: http://www.w3.org/Addressing/schemes.html#tel). */
export const phone = ns("phone");
/** A homepage for some thing. */
export const homepage = ns("homepage");
/** A weblog of some thing (whether person, group, company etc.). */
export const weblog = ns("weblog");
/** An OpenID for an Agent. */
export const openid = ns("openid");
/** A tipjar document for this agent, describing means for payment and reward. */
export const tipjar = ns("tipjar");
/** A .plan comment, in the tradition of finger and '.plan' files. */
export const plan = ns("plan");
/** Something that was made by this agent. */
export const made = ns("made");
/** An agent that
made this thing. */
export const maker = ns("maker");
/** An image that can be used to represent some thing (ie. those depictions which are particularly representative of something, eg. one's photo on a homepage). */
export const img = ns("img");
/** A depiction of some thing. */
export const depiction = ns("depiction");
/** A thing depicted in this representation. */
export const depicts = ns("depicts");
/** A derived thumbnail image. */
export const thumbnail = ns("thumbnail");
/** A Myers Briggs (MBTI) personality classification. */
export const myersBriggs = ns("myersBriggs");
/** A workplace homepage of some person; the homepage of an organization they work for. */
export const workplaceHomepage = ns("workplaceHomepage");
/** A work info homepage of some person; a page about their work for some organization. */
export const workInfoHomepage = ns("workInfoHomepage");
/** A homepage of a school attended by the person. */
export const schoolHomepage = ns("schoolHomepage");
/** A person known by this person (indicating some level of reciprocated interaction between the parties). */
export const knows = ns("knows");
/** A page about a topic of interest to this person. */
export const interest = ns("interest");
/** A thing of interest to this person. */
export const topic_interest = ns("topic_interest");
/** A link to the publications of this person. */
export const publications = ns("publications");
/** A current project this person works on. */
export const currentProject = ns("currentProject");
/** A project this person has previously worked on. */
export const pastProject = ns("pastProject");
/** An organization funding a project or person. */
export const fundedBy = ns("fundedBy");
/** A logo representing some thing. */
export const logo = ns("logo");
/** A topic of some page or document. */
export const topic = ns("topic");
/** The primary topic of some page or document. */
export const primaryTopic = ns("primaryTopic");
/** The underlying or 'focal' entity associated with some SKOS-described concept. */
export const focus = ns("focus");
/** A document that this thing is the primary topic of. */
export const isPrimaryTopicOf = ns("isPrimaryTopicOf");
/** A page or document about this thing. */
export const page = ns("page");
/** A theme. */
export const theme = ns("theme");
/** Indicates an account held by this agent. */
export const account = ns("account");
/** Indicates an account held by this agent. */
export const holdsAccount = ns("holdsAccount");
/** Indicates a homepage of the service provide for this online account. */
export const accountServiceHomepage = ns("accountServiceHomepage");
/** Indicates the name (identifier) associated with this online account. */
export const accountName = ns("accountName");
/** Indicates a member of a Group */
export const member = ns("member");
/** Indicates the class of individuals that are a member of a Group */
export const membershipClass = ns("membershipClass");
/** The birthday of this Agent, represented in mm-dd string form, eg. '12-31'. */
export const birthday = ns("birthday");
/** The age in years of some agent. */
export const age = ns("age");
/** A string expressing what the user is happy for the general public (normally) to know about their current activity. */
export const status = ns("status");
export default {
    /** Function to create arbitrary terms within the 'Friend of a Friend (FOAF) vocabulary' ontology */
    ns,
    /** A foaf:LabelProperty is any RDF property with texual values that serve as labels. */
    LabelProperty,
    /** A person. */
    Person,
    /** An agent (eg. person, group, software or physical artifact). */
    Agent,
    /** A document. */
    Document,
    /** An organization. */
    Organization,
    /** A class of Agents. */
    Group,
    /** A project (a collective endeavour of some kind). */
    Project,
    /** An image. */
    Image,
    /** A personal profile RDF document. */
    PersonalProfileDocument,
    /** An online account. */
    OnlineAccount,
    /** An online gaming account. */
    OnlineGamingAccount,
    /** An online e-commerce account. */
    OnlineEcommerceAccount,
    /** An online chat account. */
    OnlineChatAccount,
    /** A
    personal mailbox, ie. an Internet mailbox associated with exactly one owner, the first owner of this mailbox. This is a 'static inverse functional property', in that  there is (across time and change) at most one individual that ever has any particular value for foaf:mbox. */
    mbox,
    /** The sha1sum of the URI of an Internet mailbox associated with exactly one owner, the  first owner of the mailbox. */
    mbox_sha1sum,
    /** The gender of this Agent (typically but not necessarily 'male' or 'female'). */
    gender,
    /** A textual geekcode for this person, see http://www.geekcode.com/geek.html */
    geekcode,
    /** A checksum for the DNA of some thing. Joke. */
    dnaChecksum,
    /** A sha1sum hash, in hex. */
    sha1,
    /** A location that something is based near, for some broadly human notion of near. */
    based_near,
    /** Title (Mr, Mrs, Ms, Dr. etc) */
    title,
    /** A short informal nickname characterising an agent (includes login identifiers, IRC and other chat nicknames). */
    nick,
    /** A jabber ID for something. */
    jabberID,
    /** An AIM chat ID */
    aimChatID,
    /** A Skype ID */
    skypeID,
    /** An ICQ chat ID */
    icqChatID,
    /** A Yahoo chat ID */
    yahooChatID,
    /** An MSN chat ID */
    msnChatID,
    /** A name for some thing. */
    name,
    /** The first name of a person. */
    firstName,
    /** The last name of a person. */
    lastName,
    /** The given name of some person. */
    givenName,
    /** The given name of some person. */
    givenname,
    /** The surname of some person. */
    surname,
    /** The family name of some person. */
    family_name,
    /** The family name of some person. */
    familyName,
    /** A phone,  specified using fully qualified tel: URI scheme (refs: http://www.w3.org/Addressing/schemes.html#tel). */
    phone,
    /** A homepage for some thing. */
    homepage,
    /** A weblog of some thing (whether person, group, company etc.). */
    weblog,
    /** An OpenID for an Agent. */
    openid,
    /** A tipjar document for this agent, describing means for payment and reward. */
    tipjar,
    /** A .plan comment, in the tradition of finger and '.plan' files. */
    plan,
    /** Something that was made by this agent. */
    made,
    /** An agent that
    made this thing. */
    maker,
    /** An image that can be used to represent some thing (ie. those depictions which are particularly representative of something, eg. one's photo on a homepage). */
    img,
    /** A depiction of some thing. */
    depiction,
    /** A thing depicted in this representation. */
    depicts,
    /** A derived thumbnail image. */
    thumbnail,
    /** A Myers Briggs (MBTI) personality classification. */
    myersBriggs,
    /** A workplace homepage of some person; the homepage of an organization they work for. */
    workplaceHomepage,
    /** A work info homepage of some person; a page about their work for some organization. */
    workInfoHomepage,
    /** A homepage of a school attended by the person. */
    schoolHomepage,
    /** A person known by this person (indicating some level of reciprocated interaction between the parties). */
    knows,
    /** A page about a topic of interest to this person. */
    interest,
    /** A thing of interest to this person. */
    topic_interest,
    /** A link to the publications of this person. */
    publications,
    /** A current project this person works on. */
    currentProject,
    /** A project this person has previously worked on. */
    pastProject,
    /** An organization funding a project or person. */
    fundedBy,
    /** A logo representing some thing. */
    logo,
    /** A topic of some page or document. */
    topic,
    /** The primary topic of some page or document. */
    primaryTopic,
    /** The underlying or 'focal' entity associated with some SKOS-described concept. */
    focus,
    /** A document that this thing is the primary topic of. */
    isPrimaryTopicOf,
    /** A page or document about this thing. */
    page,
    /** A theme. */
    theme,
    /** Indicates an account held by this agent. */
    account,
    /** Indicates an account held by this agent. */
    holdsAccount,
    /** Indicates a homepage of the service provide for this online account. */
    accountServiceHomepage,
    /** Indicates the name (identifier) associated with this online account. */
    accountName,
    /** Indicates a member of a Group */
    member,
    /** Indicates the class of individuals that are a member of a Group */
    membershipClass,
    /** The birthday of this Agent, represented in mm-dd string form, eg. '12-31'. */
    birthday,
    /** The age in years of some agent. */
    age,
    /** A string expressing what the user is happy for the general public (normally) to know about their current activity. */
    status
};
